// GA4 (gtag.js) — laddas i webbläsaren med ett eget dataLayer (gaDataLayer),
// isolerat från GTM:s instans som annars inte konsumerar våra gtag-kommandon.
// Mät-ID kommer från connectorn (VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY).

export const MEASUREMENT_ID = import.meta.env
  .VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

const CONSENT_KEY = "fenny_consent";

declare global {
  interface Window {
    gaDataLayer?: unknown[];
    fennyGa?: (...args: unknown[]) => void;
  }
}

let initialized = false;

function hasFullConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === "all";
  } catch {
    return false;
  }
}

function pushGa(...args: unknown[]) {
  window.gaDataLayer = window.gaDataLayer || [];
  window.gaDataLayer.push(args);
}

/** Säkerställer att fennyGa-stubben finns (scriptet i <head> sätter den). */
export function initGoogleAnalytics(): void {
  if (typeof window === "undefined" || initialized) return;
  initialized = true;
  if (typeof window.fennyGa !== "function") {
    window.fennyGa = (...args: unknown[]) => pushGa(...args);
  }
}

/** Uppdaterar consent-läget när besökaren gör ett val i cookie-bannern. */
export function updateGoogleAnalyticsConsent(choice: "all" | "essential"): void {
  if (typeof window === "undefined") return;
  initGoogleAnalytics();
  // Consent Mode default sätts av GTM mot window.dataLayer; vår instans
  // delar consent-läge via GTM:s default + denna update på båda lagren.
  window.fennyGa?.("consent", "update", {
    analytics_storage: choice === "all" ? "granted" : "denied",
  });
}

/**
 * Skickar page_view vid sidladdning och SPA-navigering. GTM:s GA4-tagg
 * skickar inga sidvisningar (bara enhanced measurement som scroll), så
 * appen ansvarar för alla page_view. Vår config har send_page_view: false
 * så att gtag.js inte skickar en extra vid laddning.
 */
export function gaPageview(): void {
  if (typeof window === "undefined" || !MEASUREMENT_ID) return;
  if (!initialized) initGoogleAnalytics();
  window.fennyGa?.("event", "page_view", {
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Skickar en valfri GA4-händelse (t.ex. klick, formuläröppning, lead). */
export function gaEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === "undefined" || !MEASUREMENT_ID) return;
  if (!initialized) initGoogleAnalytics();
  if (!hasFullConsent()) return;
  window.fennyGa?.("event", name, {
    page_path: window.location.pathname,
    ...params,
  });
}
